import { useEffect, useState } from 'react';

export const useDebouncedValue = <T>(value: T, delayMs: number = 250): T => {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced as T;
};


